import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";

import CustomModal from "../../../Common/Components/Modal/CustomModal";
import { useComment, useSubmitComment } from "./Hooks";
import StarRating from "../../../Common/Components/Rate/StarRating";
import { Spinner } from "react-bootstrap";
import ItemComment from "../../../../App/Panel/Comments/subsets/ItemComment";

function List({ isApp }) {
  const { loading, getList, list, modal, setModal } = useComment();

  useEffect(() => {
    getList();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست در انتظار نظر</title>
      </Helmet>

      {isApp && <>
        {loading.list
          ? <Loading col="12" height="50px" count="3" />
          : list.data.length > 0
            ? list.data.map((item, index) => (
              <ItemComment data={item} key={index} waitCm={true}
                replayEV={() => setModal({ visible: true, data: item.id })}
              />
            ))
            : <p className="text-center mt-3 bg-transparent">  کامنتی یافت نشد !   </p>
        }
      </>}

      <>
        {!isApp && <DataTable
          loading={loading.list}
          needSearch={true}
          heads={[
            {
              title: "نام مجموعه",
              key: "name",
            },
            {
              title: "آدرس",
              key: "details",
              keyName: "address",
            },
            {
              title: "تاریخ",
              key: "created_at",
              type: "date",
              timetype: "date-time",
            },
          ]}
          textEmpty="مجموعه یی برای ثبت نظر یافت نشد"
          list={list.data}
          data={list}
          function={getList}
          currentPage={list.current_page}
          header="لیست در انتظار نظر"
          links={[
            {
              function: selected => {
                list.data.map(reserve => {
                  if (reserve.id === selected[0]) {
                    setModal({ visible: true, data: selected[0] });
                  }
                });
              },
              color: "danger",
              size: "col-md-5",
              html: "ثبت نظر",
              type: "go",
              main: true,
            },
          ]}
        />}


        <CustomModal
          show={modal.visible}
          handleClose={() => {
            setModal({ ...modal, visible: false });
            getList();
          }}
          header={"ثبت نظر"}
        >
          <CommentSubmint isApp={isApp} data={modal} />
        </CustomModal>
      </>
    </Fragment>
  );
}
const CommentSubmint = ({ data, isApp }) => {
  const { loading, sendComment, form, setForm } = useSubmitComment();
  return (
    <div className="">
      <form className=" rounded-15 p-2 ">
        <div className="row md-margin-need">
          <div className="col mb-2">
            <textarea
              rows={6}
              type="text"
              className="form-control"
              placeholder="نظر شما ..."
              onChange={e => {
                setForm({
                  ...form,
                  text: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <StarRating
          setState={setForm}
          state={form}
          style={{ flex: 1 }}
          end={true}
          text={"امتیاز"}
        />
        <div className="row mt-md-2 d-flex mx-1 md-margin-need justify-content-end">
          {/* <div className="col-md-4"> */}
          <button
            type="button"
            className={"btn btn-orange " + (isApp && "btn-primary w-100 mt-3")}
            onClick={() => sendComment({ rel_id: data && data.data })}
            disabled={loading}
            style={{
              fontSize: "16px",
            }}
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "ارسال نظر"
            )}
          </button>
          {/* </div> */}
        </div>
      </form>
    </div>
  );
};
export default List;
